/**
 * StackedBar — horizontal stacked-bar for service-share + similar
 * proportional displays. Pure CSS flexbox, no chart lib needed.
 *
 * Props:
 *   segments: { key, label, pct, color }[]  // pcts should sum to ~100
 *   activeKey?: highlight one segment with phos
 *   height?:  default 8
 */

const ACCENT = 'rgba(104,255,154,1)';
const MUTED_PALETTE = [
  'rgba(184,130,90,0.80)',  // merovingian
  'rgba(104,255,154,0.85)', // sati (active accent — overridden by activeKey)
  'rgba(106,168,184,0.80)', // sentinel
  'rgba(138,133,194,0.80)', // seraph
  'rgba(191,168,106,0.80)', // archivist
];

export default function StackedBar({ segments, activeKey, height = 8 }) {
  return (
    <div
      style={{
        display: 'flex',
        height,
        width: '100%',
        background: 'var(--rd-color-panel-lo)',
        border: '1px solid var(--rd-color-line)',
        borderRadius: 'var(--rd-radius-pill)',
        overflow: 'hidden',
      }}
    >
      {segments.map((s, i) => {
        const isActive = s.key === activeKey;
        const color = isActive ? ACCENT : s.color || MUTED_PALETTE[i % MUTED_PALETTE.length];
        return (
          <div
            key={s.key}
            title={`${s.label || s.key}: ${s.pct.toFixed(1)}%`}
            style={{
              width: `${Math.max(0.3, s.pct)}%`,
              background: color,
              transition: 'background 200ms',
            }}
            aria-label={`${s.label || s.key} ${s.pct.toFixed(1)}%`}
          />
        );
      })}
    </div>
  );
}
